import styled from 'styled-components';

export const SocialShareTitle = styled.div`
  padding-bottom: 10px;
`;

export const SocialShareFoldout = styled.ul`
  display: none;
  list-style: none;
  margin: 0 0 0 -8px;
  padding: 0;
`;

export const SocialShareFoldoutItem = styled.li`
  position: relative;
  padding-left: 8px;
`;

export const Container = styled.div`
  padding: 10px 0;

  &:hover,
  &:focus,
  &:focus-within {
    ${SocialShareTitle} > span {
      border-bottom: 1px solid #000;
    }

    ${SocialShareFoldout} {
      display: block;
    }
  }
`;
